var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTruck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.25V3.75C8.75 3.41848 8.6183 3.10054 8.38388 2.86612C8.14946 2.6317 7.83152 2.5 7.5 2.5H2.5C2.16848 2.5 1.85054 2.6317 1.61612 2.86612C1.3817 3.10054 1.25 3.41848 1.25 3.75V10.625C1.25 10.7908 1.31585 10.9497 1.43306 11.0669C1.55027 11.1842 1.70924 11.25 1.875 11.25H3.125",
    stroke: "#0F4A43",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 11.25H5.625",
    stroke: "#0F4A43",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 11.25H13.125C13.2908 11.25 13.4497 11.1842 13.5669 11.0669C13.6842 10.9497 13.75 10.7908 13.75 10.625V8.34375C13.7497 8.20191 13.7013 8.06438 13.6125 7.95375L11.4375 5.235C11.379 5.1618 11.3049 5.10268 11.2205 5.062C11.1361 5.02132 11.0437 5.00013 10.95 5H8.75",
    stroke: "#0F4A43",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 12.5C11.3154 12.5 11.875 11.9404 11.875 11.25C11.875 10.5596 11.3154 10 10.625 10C9.93464 10 9.375 10.5596 9.375 11.25C9.375 11.9404 9.93464 12.5 10.625 12.5Z",
    stroke: "#0F4A43",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 12.5C5.06536 12.5 5.625 11.9404 5.625 11.25C5.625 10.5596 5.06536 10 4.375 10C3.68464 10 3.125 10.5596 3.125 11.25C3.125 11.9404 3.68464 12.5 4.375 12.5Z",
    stroke: "#0F4A43",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTruck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/truck.0b893231.svg";
export { ForwardRef as ReactComponent };